/* eslint-disable @typescript-eslint/no-explicit-any */
// Core
import { loader } from 'graphql.macro';
import { useMutationRequest } from '../../../hooks/feature/useMutationRequest';
import {
  PropType,
  PropTypes,
  UseCheckInvite,
  UseCheckPinCodeData,
  UseHcpSendPinCode,
  UseResentInvite,
  UseSignUpCreate,
} from '../types';
// Mutations
const mutationSendPinCode = loader('./gql/mutationSendPinCode.graphql');
const mutationHcpCheckPinCodeData = loader('./gql/mutationCheckPinCodeData.graphql');
const mutationSignUp = loader('./gql/mutationSignUp.graphql');
const mutationCheckInviteToken = loader('./gql/mutationCheckInviteToken.graphql');
const mutationRequestInvitation = loader('./gql/mutationRequestInvitation.graphql');

export const useCheckInvite = (): UseCheckInvite => {
  const [_checkToken, { data, errorText, loading }] = useMutationRequest<{
    checkInviteToken: { email: string };
  }>(mutationCheckInviteToken, {});
  const _checkInviteToken = (token: PropTypes): void => {
    _checkToken({
      variables: {
        inviteToken: token,
      },
    });
  };
  return {
    _checkInviteToken,
    dataInvite: data && data.checkInviteToken,
    errorInvite: errorText,
    loading,
  };
};

export const useHcpSendPinCode = (): UseHcpSendPinCode => {
  const [_send, { data, errorText, loading }] = useMutationRequest<{ hcpSendPinCode: {} }>(
    mutationSendPinCode,
    {},
  );
  const _sendPinCode = (token: string): void => {
    _send({
      variables: {
        sendPinCodeData: {
          inviteToken: token,
        },
      },
    });
  };

  return {
    _sendPinCode,
    dataPinCode: data && data.hcpSendPinCode,
    errorPinCode: errorText,
    loadingSensPin: loading,
  };
};

export const useSignUpCreate = (): UseSignUpCreate => {
  const [_send, { data, errorText, loading }] = useMutationRequest<{
    hcpSignUp: { access_token: string; refresh_token: string };
  }>(mutationSignUp, {});

  const _signUp = (property: any, token: string): void => {
    if (property && token) {
      const signUpData = {
        password: property.password,
        repeatPassword: property.repeatpassword,
        inviteToken: token,
      };
      _send({
        variables: {
          hcpSignUpData: signUpData,
        },
      });
    }
  };

  return {
    _signUp,
    dataSignUp: data && data.hcpSignUp,
    errorSignUp: errorText,
    loadingSignUp: loading,
  };
};

export const useCheckPinCodeData = (): UseCheckPinCodeData => {
  const [_send, { data, errorText, loading }] = useMutationRequest<{
    hcpCheckPinCode: { inviteToken: string };
  }>(mutationHcpCheckPinCodeData, {});

  const _sendVarefiredPin = (sendData: PropType): void => {
    _send({
      variables: {
        checkPinCodeData: sendData,
      },
    });
  };

  return {
    _sendVarefiredPin,
    dataVarefiredPin: data && data.hcpCheckPinCode,
    errorVarefiredCode: errorText,
    checkPinLoading: loading,
  };
};

export const useResentInvite = (): UseResentInvite => {
  const [_send, { data, errorText, loading }] = useMutationRequest<{
    requestToResendHcpInvitation: boolean;
  }>(mutationRequestInvitation, {});

  const _sendInvite = (sendInviteData: PropType): void => {
    _send({
      variables: {
        expiredInviteToken: sendInviteData,
      },
    });
  };

  return {
    _sendInvite,
    resentInviteData: data && data.requestToResendHcpInvitation,
    errorInviteData: errorText,
    resentInviteLoading: loading,
  };
};
